import { render, staticRenderFns } from "./ShoppingSingle.vue?vue&type=template&id=cdbf53bc&scoped=true&lang=pug&"
import script from "./ShoppingSingle.vue?vue&type=script&lang=js&"
export * from "./ShoppingSingle.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingSingle.vue?vue&type=style&index=0&id=cdbf53bc&lang=scss&scoped=true&"
import style1 from "./ShoppingSingle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbf53bc",
  null
  
)

export default component.exports